export const DATA = {
    personal: {
        avatar: "/me.jpg",
        name: "Parham Khamsepour",
        profile: "Motivated Computer Scientist and Software Engineer with an MSc in Computer Science and over 7 years of combined experience in development and research. Currently a PhD candidate at the University of Ottawa, specializing in Software Engineering, Artificial Intelligence, and Large Language Models (LLMs). I possess deep technical expertise in algorithms, data structures, and machine learning pipelines, bridging the gap between academic research and industrial application. Passionate educator and mentor, having guided over 1,000 students in their technical development.",
        basicInformation: [
            {
                icon: 'envelope',
                value: 'parham.khamsepour@uottawa.ca'
            },
            {
                icon: 'envelope',
                value: 'contact@parhamkhamsepour.com'
            },
            {
                icon: 'phone',
                value: '+1 226 506 4245'
            },
            {
                icon: 'language',
                value: ['Persian', 'English']
            },
            {
                icon: 'cake-candles',
                value: 'June 22, 1998'
            },
            {
                icon: 'location-dot',
                value: 'Ottawa, ON, Canada'
            },
            {
                icon: 'file-arrow-down',
                value: 'Resumé',
                role: 'cv'
            }
        ],
        socials: [
            {
                icon: 'linkedin-in',
                url: 'https://www.linkedin.com/in/parhamkhamsepour/'
            },
            {
                icon: 'github',
                url: 'https://github.com/parham-box'
            }
        ]
    },
    skills: [
        {
            name: "Machine Learning and Data Science",
            tools: [
                {
                    level: "Academic & Experienced",
                    names: ["Python", "Langchain", "LLMs", "RAG Pipelines", "HuggingFace", "NLP", "PyTorch"]
                }
            ]
        },
        {
            name: "Back-End/RESTFul API Development",
            tools: [
                {
                    level: "Experienced",
                    names: ["Node.JS", "NestJS", "TypeScript", "Ruby(Rails)", "PHP(Laravel)", "Express"]
                },
                {
                    level: "Familiar",
                    names: ["Python(Django)", "C#(ASP.NET MVC)"]
                }
            ]
        },
        {
            name: "Mobile Application Development",
            tools: [
                {
                    level: "Experienced",
                    names: ["Swift", "SwiftUI", "Java"]
                },
                {
                    level: "Familiar",
                    names: ["Flutter", "React Native"]
                }
            ]
        },
        {
            name: "Front-end Development",
            tools: [
                {
                    level: "Experienced",
                    names: ["React", "HTML", "CSS", "JavaScript", "TypeScript"]
                },
                {
                    level: "Familiar",
                    names: ["Vue"]
                }
            ]
        },
        {
            name: "Databases",
            tools: [
                {
                    level: "Experienced",
                    names: ["PostgreSQL", "MySQL", "SQLServer", "Database Design"]
                },
                {
                    level: "Familiar",
                    names: ["MongoDB"]
                }
            ]
        },
        {
            name: "DevOps & Cloud",
            tools: [
                {
                    level: "Experienced",
                    names: ["Docker", "Kubernetes", "CI/CD (Azure/Tekton)", "OpenShift", "Azure DevOps"]
                }
            ]
        },
        {
            name: "Others",
            tools: [
                {
                    level: "Experienced",
                    names: ["Algorithms", "Data Structures", "GraphQL", "MVC/MVVM", "C/C++", "Java", "LaTeX", "Git"]
                }
            ]
        },
    ],
    education: [
        {
            level: "High School",
            major: "Mathematics",
            institution: "Pasargad High School",
            startYear: "2012",
            endYear: "2016",
            description: "Ranked in the top 4% among ~163,000 participants in Iran's National University Entrance Exam. Graduated with a GPA of 18.61/20."
        },
        {
            level: "Bachelor Degree",
            major: "Software Engineering",
            institution: "Imam Khomeini International University, Qazvin, Iran",
            startYear: "2016",
            endYear: "2020",
            website: "https://ikiu.ac.ir",
            description: "Graduated in the top 5% of the class (GPA: 17.66/20). Selected member of the university's Computer Olympiad team and competed in the ICPC International Collegiate Programming Contest."
        },
        {
            level: "Master's Degree (Thesis Based)",
            major: "Computer Science",
            institution: "University Of Windsor, Ontario, Canada",
            startYear: "2021",
            endYear: "2023",
            website: "https://uwindsor.ca",
            description: "Specialized in Artificial Intelligence through a Vector Institute recognized program. Thesis: 'The Minimum Consistent Spanning Subset Problem on Trees' (Supervised by Dr. Ahmad Biniaz). Achieved a grade of 94.56/100. Recipient of the University of Windsor Entrance and Departmental Scholarships."
        },

        {
            level: "Doctor of Philosophy (PhD)",
            major: "Computer Science",
            institution: "University Of Ottawa, Ontario, Canada",
            startYear: "2024",
            endYear: "Present",
            website: "https://uottawa.ca",
            description: "Conducting research on the application of Large Language Models (LLM) in software engineering, specifically Model-Driven Engineering. Supervising professors: Dr. Shiva Nejati and Dr. Mehrdad Sabetzadeh (Sedna Research Lab). Collaborating closely with Ciena to solve industrial-scale problems. Current GPA: A+."
        },
    ],
    experience: {
        work: [
            {
                name: "Nahira Co.",
                role: "iOS Developer",
                description: [
                    "Developed and maintained various native iOS applications using Swift.",
                    "Collaborated with design teams to implement responsive user interfaces."
                ],
                startYear: "2018",
                endYear: "2018"
            },
            {
                name: "Reeno Co.",
                role: "Intern Engineer",
                description: [
                    "Designed and developed a web-based recycling portal using PHP and Laravel.",
                    "Facilitated the logging and management of recycled devices for a regional environmental festival."
                ],
                startYear: "2019",
                endYear: "2019"
            },
            {
                name: "Motion Gestures",
                role: "iOS Developer",
                description: [
                    "Developed high-performance image processing pipelines using Swift.",
                    "Leveraged Apple’s local frameworks to extract and process camera layers for real-time gesture recognition models."
                ],
                startYear: "Nov 2021",
                endYear: "Jan 2022"
            },

            {
                name: "University of Windsor",
                role: "Graduate Teaching & Research Assistant",
                description: [
                    "Conducted research on algorithm design and data structures under the supervision of Dr. Ahmad Biniaz.",
                    "Served as Invited Lecturer for Theoretical Foundations of Computer Science and Computer Architecture courses.",
                    "Evaluated exams and technical reports, providing detailed feedback to undergraduate students."
                ],
                startYear: "Sep 2021",
                endYear: "May 2023",
                url: "https://uwindsor.ca"
            },
            {
                name: "AgileIS Co",
                role: "Software Developer",
                description: [
                    "Engineered UI and API enhancements for health-tech applications in an Agile environment.",
                    "Maintained and optimized CI/CD pipelines (Azure DevOps) and dependency management systems.",
                    "Implemented end-to-end (e2e) testing frameworks to ensure application reliability."
                ],
                startYear: "Jun 2023",
                endYear: "Aug 2023",
            },

            {
                name: "LightHouse Labs",
                role: "Full-stack Web Development Mentor",
                description: [
                    "Mentor over 1,000 students in modern web development stacks, algorithms, and database management.",
                    "Provide high-level technical guidance on Node.js, React, Ruby on Rails, and PostgreSQL.",
                    "Debug complex student code and facilitate the development of problem-solving skills."
                ],
                startYear: "Jan 2022",
                endYear: "Sep 2024",
            },

            {
                name: "University of Ottawa",
                role: "Graduate Teaching & Research Assistant",
                description: [
                    "Serve as Head Teaching Assistant for ITI-1120: Introduction to Computing I, coordinating operations for undergraduate students and other TAs.",
                    "Deliver guest lectures for SEG-2106: Software Construction and ITI-1120: Introduction to Computing I.",
                    "Supervised an undergraduate student, providing guidance on research methodology and technical report writing."
                ],
                startYear: "Sep 2024",
                endYear: "Present",
                url: "https://uottawa.ca"
            },

            {
                name: "Ciena",
                role: "Software Researcher Intern",
                description: [
                    "Researched and designed state-of-the-art Retrieval Augmented Generation (RAG) pipelines to automate technical support queries.",
                    "Evaluated various Large Language Models (LLMs) to optimize generation accuracy and context retrieval.",
                    "Collaborated with the Ciena engineers to deploy AI solutions in an industrial environment."
                ],
                startYear: "Jun 2024",
                endYear: "Present",
                url: "https://www.ciena.com"
            },

        ],
        project: [
            {
                name: "FitSho",
                role: "Full-Stack Developer",
                description: [
                    "Architected a comprehensive workout and dietary plan platform using Laravel and Bootstrap.",
                    "Designed a complex relational database structure, which served as the capstone project for my Bachelor's degree."
                ],
                startYear: "2018",
                endYear: "2018"
            },
            {
                name: "Local Search Engine",
                role: "Developer",
                description: [
                    "Built a local search engine with custom ranking algorithms using Java.",
                    "Implemented indexing and retrieval mechanisms for the Information Retrieval course capstone."
                ],
                startYear: "2019",
                endYear: "2019"
            },
            {
                name: "Movie Sorter",
                role: "Developer",
                description: [
                    "Developed a file management utility in Java to organize media libraries.",
                    "Utilized advanced Regular Expressions to parse and sort movie files by metadata."
                ],
                startYear: "2019",
                endYear: "2019"
            },
            {
                name: "This Website",
                role: "Developer",
                description: [
                    "Designed and built a React-based portfolio site.",
                    "Implemented a data-driven architecture where all content is dynamically rendered from a JSON configuration file."
                ],
                startYear: "2022",
                endYear: "2022"
            },
        ],
    },
    awards: [
        {
            title: "Ontario Graduate Scholarship (OGS)",
            institution: "University of Ottawa",
            year: "2024-2025",
            description: "Merit-based scholarship awarded for excellence in graduate studies and research potential."
        },
        {
            title: "Doctoral Graduate Admission Scholarship",
            institution: "University of Ottawa",
            year: "2024-2028",
            description: "Awarded upon admission to the PhD program in recognition of academic excellence."
        },
        {
            title: "Special Merit Scholarship",
            institution: "University of Ottawa",
            year: "2024-2025",
            description: "Awarded for exceptional academic achievement during doctoral studies."
        },
        {
            title: "Entrance Scholarship",
            institution: "University of Windsor",
            year: "2021-2022",
            description: "Awarded for high academic standing upon entering the Master of Science program."
        },
        {
            title: "Departmental Scholarship",
            institution: "University of Windsor",
            year: "2021",
            description: "Awarded by the Department of Computer Science for academic merit."
        }
    ],
    publications: [
        {
            title: "RAG-based Question Answering for Multi-Release Systems: Approach and Industrial Case Study",
            authors: ["P. Khamsepour", "M. Cole", "I. Ashraf", "S. Puri", "M. Sabetzade", "S. Nejati"],
            type: "Conference",
            publishedAt: "2026",
            publication: "The 33rd IEEE International Conference on Software Analysis, Evolution and Reengineering (SANER)",
            url: "https://arxiv.org/abs/2601.02345",
            abstract: "Addresses the industrial challenge of answering questions from technical documentation for different releases of the same product. We proposed and deployed a solution based on Large Language Models (LLMs) and Retrieval-Augmented Generation (RAG) that is aware of different document releases. The solution automates technical support and improves customer service by providing correct, release-aware answers.",
        },
        {
            title: "The Impact of Critique on LLM-Based Model Generation from Natural Language: The Case of Activity Diagrams",
            authors: ["P. Khamsepour", "M. Cole", "I. Ashraf", "S. Puri", "M. Sabetzade", "S. Nejati"],
            type: "Journal (Submitted)",
            publishedAt: "2025",
            publication: "Submitted",
            url: "https://arxiv.org/abs/2509.03463",
            abstract: "Addresses the challenge of creating software models manually from natural-language procedural text. We proposed and deployed a solution that leverages LLMs to generate activity diagrams from process descriptions, utilizing a novel mechanism for iterative critique and refinement. This work advances LLM-based software modelling by improving generation reliability.",
        },
        {
            title: "The Minimum Consistent Spanning Subset Problem on Trees",
            authors: ["Parham Khamsepour", "Ahmad Biniaz"],
            type: "Journal",
            publishedAt: "2024",
            publication: "Journal of Graph Algorithms and Applications",
            url: "http://dx.doi.org/10.7155/jgaa.v28i1.2929",
            abstract: "Given a vertex-colored edge-weighted graph, the minimum consistent subset (MCS) problem asks for a minimum subset S of vertices such that every vertex v ∉ S has the same color as its nearest neighbor in S. We presented a polynomial-time algorithm for this problem on trees, whereas the problem remains NP-complete on general graphs.",
        },
    ]
};